import { gql } from '@apollo/client';
import { ResponseLabelFields } from './response.fragments';

export const QuestionLabelFields = gql`
  fragment QuestionLabelFields on Question {
    labelsConnection {
      edges {
        properties {
          condition
        }
        node {
          value
        }
      }
    }
  }
`;

export const ALL_QUESTION_FIELDS = gql`
  ${QuestionLabelFields}
  ${ResponseLabelFields}
  fragment AllQuestionFields on Question {
    id
    extId
    format
    section
    sectionsConnection {
      edges {
        properties {
          condition
        }
        node {
          id
          value
        }
      }
    }
    multipleChoice
    paginateResponses
    required
    hideResponsesByDefault
    conditions
    ...QuestionLabelFields
    commentsConnection {
      edges {
        properties {
          condition
        }
        node {
          id
          value
        }
      }
    }
    placeholdersConnection {
      edges {
        properties {
          condition
        }
        node {
          id
          value
        }
      }
    }
    helpConnection {
      edges {
        properties {
          condition
        }
        node {
          id
          value
        }
      }
    }
    afterConnection {
      edges {
        properties {
          condition
        }
        node {
          extId
        }
      }
    }
    responses {
      id
      extId
      format
      multipleChoice
      exclusive
      alwaysShowLabel
      level
      conditions
      keywords
      emoji
      documentKey
      documentLabel
      documentMultipleAllowed
      documentCaptureMethod
      documentCategory
      documentUrl
      assertions {
        id
        value
      }
      ...ResponseLabelFields
      insertsReponses {
        extId
      }
      insertsQuestions {
        extId
        afterConnection {
          edges {
            properties {
              condition
            }
            node {
              extId
            }
          }
        }
      }
      deletesQuestions {
        extId
        afterConnection {
          edges {
            properties {
              condition
            }
            node {
              extId
            }
          }
        }
      }
      questionConnection {
        edges {
          properties {
            condition
          }
          node {
            extId
          }
        }
      }
      afterConnection {
        edges {
          properties {
            condition
          }
          node {
            extId
          }
        }
      }
      reportsConnection {
        edges {
          properties {
            condition
          }
          node {
            id
            classification
            value
            concatenate
            quote
            indent
            level
            new
            questionnaire
            documentKey
            explanationsConnection {
              edges {
                properties {
                  condition
                }
                node {
                  id
                  value
                  level
                }
              }
            }
          }
        }
      }
      unitConnection {
        edges {
          properties {
            condition
          }
          node {
            plural
            singular
          }
        }
      }
      minimumConnection {
        edges {
          properties {
            condition
          }
          node {
            value
          }
        }
      }
      maximumConnection {
        edges {
          properties {
            condition
          }
          node {
            value
          }
        }
      }
      incrementConnection {
        edges {
          properties {
            condition
          }
          node {
            value
          }
        }
      }
      checklistItemsConnection {
        edges {
          properties {
            condition
          }
          node {
            value
            family
          }
        }
      }
      commentsConnection {
        edges {
          properties {
            condition
          }
          node {
            id
            value
          }
        }
      }
    }
  }
`;
